import loadLightbox, { open } from ".";

const generateD365CoachingForm = ({
  elClassName
}: {
  elClassName?: string;
}) => {
  var dataForm = document.createElement("div");
  var script1 = document.createElement("script");
  var el = document.querySelector(`.${elClassName}`) || document.body;
  var formSrc =
    "https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/gbr/FormLoader/FormLoader.bundle.js";

  dataForm.setAttribute("data-form-id", `${process.env.COACHING_DATAFORM_ID}`);
  dataForm.setAttribute(
    "data-form-api-url",
    `https://public-gbr.mkt.dynamics.com/api/v1.0/orgs/${process.env.COACHING_DATAFORM_API_ID}/landingpageforms`
  );
  dataForm.setAttribute(
    "data-cached-form-url",
    `https://assets-gbr.mkt.dynamics.com/${process.env.COACHING_DATAFORM_API_ID}/digitalassets/forms/${process.env.COACHING_DATAFORM_ID}`
  );
  script1.src = `${process.env.COACHING_FORM_SCRIPT || formSrc}`;

  el.appendChild(dataForm);
  el.appendChild(script1);
};

export const load365Form = () => {
  if (!!document.querySelector(".open-coaching-lb")) {
    const btn: HTMLButtonElement | null = document.querySelector(
      ".open-coaching-lb"
    );
    const banners = Array.from(
      document.querySelectorAll(".landing-page__tile-bg")
    );

    let LightboxWrapper = document.createElement("div");
    LightboxWrapper.className = "lightbox hide";
    LightboxWrapper.innerHTML = `<div class="lightbox-container container">
        <div class="lightbox__close"></div>
        <div class="lightbox-dialogue">
          <div class="form coaching-form-d365">
          <section class="lightbox__form-container">
            <h2>Coaching Newsletter Sign Up</h2>
          </section>
          </div>
        </div>
      </div>`;

    if (!!!document.querySelector(`.${LightboxWrapper.className}`)) {
      document.body.insertBefore(LightboxWrapper, document.body.children[0]);

      generateD365CoachingForm({ elClassName: "coaching-form-d365" });
      loadLightbox({
        containerClassName: ".lightbox",
        elClassName: "sign-up",
        otherClasses: ["newsletter-form"],
        dynamic: false
      });

      if (!!btn) {
        if (
          banners.length &&
          !!banners[0].querySelector(".landing-page__tile-bg-text")
        ) {
          let node = document.createElement("button");
          node.innerHTML = btn.innerHTML;
          node.className = "btn btn--clear";
          node.addEventListener("click", () => {
            open({
              className: "sign-up",
              containerClassName: ".lightbox"
            });
          });
          // @ts-ignore
          banners[0]
            .querySelector(".landing-page__tile-bg-text")
            .appendChild(node);
          btn.remove();
        }
      }
    }
  }
};
